import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';
import styled from 'styled-components';

export const TabsWrapper = styled.div`
  ${flex({ alignItems: 'center' })}
  gap: 4px;
  border-bottom: 1px solid ${COLORS.grey[300]};
`;
